import React, { Fragment } from 'react';

import API from '../../../../utils/API';

import FieldModal from '../../../../components/modals/fieldModal';

import InputField from '../../../../components/inputs/inputField';
import { withRouter } from 'react-router-dom';

class DuplicateCampaignModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			name: this.props.email.name ? this.props.email.name.concat(' Copy') : '',
			submitting: false,
			requiredFields: { name: false }
		};
	}

	handleNameChange = (e) => {
		this.setState({
			name: e.target.value
		});
	};

	duplicateCampaign = async () => {
		this.setState({ submitting: true });
		const { name } = this.state;
		const { eventId, orgId, email, update, toggle } = this.props;
		const requiredFields = this.state.requiredFields;
		let valid = true;
		if (!name) {
			requiredFields.name = true;
			valid = false;
		}

		if (valid) {
			await API()
				.post(`Organizations/${orgId}/events/${eventId}/email`, { name: name, duplicateEmailId: email._id })
				.then((res) => {
					const campaignObj = res.data;

					if (res.data) {
						window.open(`/${orgId}/events/${eventId}/emails/${campaignObj._id}`, '_self');
					} else {
					}
				});
		} else {
			this.setState({ submitting: false, requiredFields: requiredFields });
		}
	};

	render() {
		const { isOpen, toggle } = this.props;
		const { submitting, name, requiredFields } = this.state;

		return (
			<div>

				<FieldModal
					size="small"
					isOpen={isOpen}
					modalTitle={"Duplicate Campaign"}
					bodyHeaderText={'Enter a new name for your campaign.'}
					bodyDescription={''}
					bodyContent={() => {
						return (
							<div>
								<InputField
									label="Name"
									value={name}
									required={true}
									errorTrigger={requiredFields.name}
									onChange={this.handleNameChange}
								/>
							</div>)
					}}
					toggle={toggle}
					actionButtonLabel={!submitting ? 'Save' : 'Saving...'}
					actionButton={() => this.duplicateCampaign()}
					actionButtonDisabled={submitting}


				></FieldModal>

			</div>

		);
	}
}

export default withRouter(DuplicateCampaignModal);
